
import React from "react";

interface TestimonialSectionProps {
  quote: string;
  author: {
    name: string;
    role: string;
    avatarSrc: string;
  };
}

const TestimonialSection: React.FC<TestimonialSectionProps> = ({
  quote,
  author
}) => {
  return (
    <section className="py-20 bg-[#072c39] text-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <svg className="w-12 h-12 text-drcash-caribbean-green mx-auto mb-4" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
              <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
            </svg>
            <blockquote>
              <p className="text-xl md:text-2xl font-medium leading-relaxed">{quote}</p>
            </blockquote>
          </div>
          <div className="flex items-center justify-center mt-8">
            <img 
              src={author.avatarSrc} 
              alt={author.name} 
              className="h-12 w-12 rounded-full object-cover mr-4"
            />
            <div className="text-left">
              <p className="font-medium text-white">{author.name}</p>
              <p className="text-drcash-cadet-gray text-sm">{author.role}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
